<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.margin-bottom-filtro {
  margin-bottom: 15px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue